<template lang="pug">
.aov_box
  .aov_header
    .aov_bg(:style='computedStyle')
      img.logo_img.img(src='./img/MondoMenu-logo.png')
      .bg_content
        .con_text
          .title {{ headerTitle }}
          .checked
            .checked_icons
              mu-icon(value='check_circle', v-for='item in 4', :key='item')
            .checked_text
              .row(v-for='item in headerText', :key='item') {{ item }}
          el-button.find_btn(@click='goMore') Find out more
        img.con_img(v-if='isAov', :src='headerImg')

  .arrow.bounce(:style='{ opacity: bounceOpacity, display: bounceOpacity === 1 ? "flex" : "none"}', @click='nextPage')
    icon(size='38', color='#fff') arrow_downward

  #a.aov_public_profitability
    .aov_public_title Look good, sell more, grow fast
    .aov_public_label
    .aov_public_describe Unlock the revenue potential of your menu! MondoMenu’s innovative features encourage customers to spend more while also enhancing the ordering experience.
    .aov_public_content
      .content_box(v-for='(item, index) in profitabilityList', :key='index')
        img.content_img(:src='item.img')
        .content_title {{ item.title }}
        .content_label {{ item.text }}

  .aov_public_simple
    .aov_public_title Simple for customers
    .aov_public_label
    .aov_public_describe(v-if='isAov') It’s time to ditch the paper menu! Without the need to download an app or wave down a waiter, your customers simply scan a QR code to order from your beautiful visual menu.
    .aov_public_describe(v-else) Give your customers the ordering experience they deserve! No need to download an app or create an account.
    .aov_public_content(:class='{ delivery_con: !isAov }')
      .content_box
        img.content_img(:src='isAov ? scanQRCode : accessMenu')
        .content_title STEP 1
        .content_label {{ isAov ? "Customers scan a QR code at their table to see the menu." : "Customers access your menu via your website, socials, SMS or email." }}

      .content_box
        img.content_img(:src='isAov ? accessMenu : PlaceOrder')
        .content_title STEP 2
        .content_label {{ isAov ? "Customers place their order and make a payment using their preferred payment method." : "They browse, order and pay via your digital menu." }}

      .content_box
        img.content_img(:src='isAov ? notification : WaitTime')
        .content_title.font_22 STEP 3
        .content_label {{ isAov ? "Customers have their meal brought to their table or receive an SMS alerting them to collect their order." : "Customers are notified of their pick-up/delivery time based on your average preparation time. " }}
    .aov_public_video(v-if='isAov')
      iframe._video(
        width='740',
        height='416',
        src='https://www.youtube.com/embed/FYJ1iFbwB8w',
        title='YouTube video player',
        frameborder='0',
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        allowfullscreen
      )

  .aov_public_videoBox
    .aov_public_title Easy to setup and manage
    .aov_public_label
    .aov_public_describe You have full control over your menu, images and pricing from the MondoMenu portal.
    .aov_public_video
      iframe(
        width='740',
        height='416',
        src='https://www.youtube.com/embed/R9pa4gPaxNo',
        title='YouTube video player',
        frameborder='0',
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        allowfullscreen
      )

  .aov_public_why
    .aov_public_title Why MondoMenu?
    .aov_public_label
    .aov_public_content
      .tip(v-for='item in whyList', :key='item')
        mu-icon.why_icon(value='done')
        .text_con {{ item }}

  .aov_public_brands
    .aov_public_title Venues already on board
    .aov_public_label
    .aov_public_describe Join a growing list of venues using MondoMenu to increase their average order value.
    infinite-slide-bar.swiper(duration="20s")
      .items
        .box(v-for="item in 2" :key="item")
          img.content_img(src='./img/Glasshouse-bar.jpg')
          img.content_img(src='./img/Emirates.jpg')
          img.content_img(src='./img/Rovers.jpg')
          img.content_img(src='./img/Bathers.jpg')
          img.content_img(src='./img/Betel-Leaf.jpg')
          img.content_img(src='./img/Kiosk.jpg')
          img.content_img(src='./img/The-Prince.jpg')
          img.content_img(src='./img/Fouth.jpg')
          img.content_img(src='./img/Arabesque.jpg')

  #more.aov_public_form
    .aov_public_title Find out more
    .aov_public_label
    .aov_public_describe Let us show you how we can increase your average order value by over 40%!
    .aov_from_box
      .form_sty
        .from_box
          py-form(
            ref='form',
            :model='formLabelAlign',
            :rules='formRuleValidate'
          )
            py-form-item(prop='firstName')
              landing-input(
                v-model='formLabelAlign.firstName',
                :label='"Full name*"'
              )
            py-form-item(prop='email')
              landing-input(v-model='formLabelAlign.email', :label='"Email*"')
            py-form-item(prop='mobile')
              landing-input(
                v-model='formLabelAlign.mobile',
                :label='"Mobile number"'
              )
            py-form-item(prop='jobTitle')
              landing-input(
                v-model='formLabelAlign.jobTitle',
                :label='"Job title*"'
              )
            py-form-item(prop='')
              landing-input(
                v-model='formLabelAlign.venueName',
                :label='"Venue name"'
              )

          .aov_checkbox
            .checkbox_label Are you interested in:
            el-checkbox-group(v-model='formLabelAlign.interested')
              el-checkbox(label='In table dining')
              el-checkbox(label='Pickup')
              el-checkbox(label='Preorder')
              el-checkbox(label='Delivery')

          .aov_radio_box
            .checkbox_label Preferred contact method:
            el-radio-group(v-model='formLabelAlign.contactMethod')
              el-radio(label='Email') Email
              el-radio(label='Phone') Phone

          el-button.bot_sty(
            @click='submitFrom($route.name === "aov" ? "aov" : "delivery")'
          ) Submit

  .aov_bottom_box
    .bottom_label Follow us on:
    .icon_sty
      svg-icon(icon-class='instagram', @click='toRouter("instagram")')
    mu-icon.child_icon(
      value='facebook',
      size='32',
      color='#10CFC9',
      @click='toRouter("facebook")'
    )

  Dialog(width='388PX', :visible.sync='openShow', :show-close='false')
    .dialog
      img.dialog_img(src='./img/Tick-Icon.png')
      .title {{ t('thanks_for_registering', 'Thanks for registering your interest!') }}
      .title.test {{ t('we_will_be_in_touch', 'We will be in touch with you shortly.') }}
      el-button.dialog_button(@click='openShow = false') {{ t('ok', 'OK') }}
</template>
<script>
import mixin from './mixin'
import aovImg from './img/Banner-image-AOV.jpg'
import deliveryImg from './img/Banner-image-delivery.jpg'
import InfiniteSlideBar from 'vue-infinite-slide-bar'
import { Dialog } from 'element-ui'

export default {
  name: 'pcAov',

  mixins: [mixin],

  components: {
    InfiniteSlideBar,
    Dialog
  },

  data() {
    return {
      options: {
        slidesPerView: 'auto',
        loop: true,
        speed: 500,
        observer: true,
        observeParents: true,
        autoplayDisableOnInteraction: false,
      },
      computedStyle: {
        position: 'relative',
        width: '100%',
        height: '62.5vw',
        backgroundImage:
          this.$route.name === 'aov'
            ? `url('${aovImg}')`
            : `url('${deliveryImg}')`,
        backgroundSize: 'cover',
      },
    }
  },
}
</script>

<style lang="sass" scoped>
.aov_from_box
  .form_sty
    display: flex
    justify-content: center
    align-items: center

    .from_box
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center

    .from_text
      font-size: 40PX

    ::v-deep
      .py_form_item_box
        padding-bottom: 0

.aov_from_title
  width: 475PX
  font-size: 35PX
  font-weight: bold
  line-height: 41PX
  color: #334455

  @media screen and (max-height: 800PX)
    font-size: 30PX

  @media screen and (max-height: 720PX)
    font-size: 20PX
    line-height: 20PX

.aov_from_text
  width: 475PX
  margin: 20PX 0
  font-size: 20PX
  font-weight: 400
  line-height: 24PX
  color: #334455
  opacity: .75

  @media screen and (max-height: 800PX)
    margin: 10PX 0
    font-size: 17PX

.bot_sty
  width: 475PX
  height: 54PX
  background: #10CFC9
  border-radius: 4PX
  font-size: 22PX
  font-weight: bold
  line-height: 20PX
  color: #FFFFFF

.aov_box
  .aov_header
    position: relative

    .aov_bg
      position: relative
      width: 100vw
      height: 62.5vw

      .logo_img
        position: absolute
        top: 60PX
        left: 90PX
        width: 269PX
        height: 52PX
        vertical-align: middle

      .bg_content
        display: flex
        justify-content: space-between
        align-items: center
        height: 100%
        padding: 0 90PX

        .con_text
          margin-top: 20PX

          .title
            width: 459PX
            font-size: 45PX
            font-family: Raleway
            font-weight: bold
            line-height: 54PX
            color: #FFFFFF

          .checked
            display: flex
            margin-top: 40PX

            .checked_icons
              display: flex
              flex-direction: column
              margin-right: 12PX

              ::v-deep .material-icons
                margin-bottom: 10PX
                font-size: 30PX
                color: #fff

                &:last-child
                  margin-bottom: 0

          .checked_text
            .row
              margin-bottom: 20PX
              font-size: 20PX
              font-family: Roboto
              font-weight: 400
              line-height: 20PX
              color: #FFFFFF

              &:last-child
                margin-bottom: 0

        .con_img
          width: 41.41%
          margin-top: 20PX
          vertical-align: middle

        .find_btn
          width: 255PX
          height: 54PX
          margin-top: 40PX
          font-size: 22PX
          font-family: Roboto
          font-weight: bold
          color: #FFFFFF
          text-transform: uppercase
          border-radius: 4PX
          background: #10CFC9

    .aov_img
      height: 100vh
      background-size: cover

    .aov_log
      position: absolute
      top: 60PX
      left: 60PX
      width: 269PX
      height: 52PX

  .aov_public_brands,
  .aov_public_simple,
  .aov_public_profitability,
  .aov_public_videoBox,
  .aov_public_why,
  .aov_public_form
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center

    .aov_public_label
      width: 150PX
      height: 8PX
      margin-bottom: 22PX
      background: #10CFC9

    .aov_public_describe
      width: 830PX
      margin-bottom: 30PX
      text-align: center
      font-size: 14PX
      font-family: Roboto
      font-weight: 400
      line-height: 20PX
      color: #334455
      opacity: 0.75

    .aov_public_title
      margin: 51PX 0PX 25PX 0PX
      font-size: 30PX
      font-weight: bold
      line-height: 36PX
      color: #334455

    .aov_public_content
      display: flex
      flex-wrap: wrap
      justify-content: space-between
      width: 1280PX

      @media screen and (max-width: 1280PX)
        width: 100%

      .content_box
        flex: 1
        display: flex
        flex-direction: column
        align-items: center
        margin-bottom: 18PX
        opacity: 0
        transform: translateY(20PX)
        transition: all 1s

        &.animation
          opacity: 1
          transform: translateY(0)

        .content_img
          width: 85PX
          margin-bottom: 15PX

        .content_label
          width: 320PX
          font-size: 14PX
          font-weight: 400
          line-height: 20PX
          color: #334455
          opacity: .75
          text-align: center

          @media screen and (max-width: 960PX)
            width: auto

  .aov_public_form
    padding-bottom: 56PX
    background: #F8F9FA

    .aov_public_describe
      margin-bottom: 25PX

  .aov_public_profitability
    background: #ffffff
    padding-bottom: 14PX

    .aov_public_content
      .content_box
        &:nth-last-of-type(2)
          .content_img
            margin-top: 0

        .content_img
          margin-top: 17PX

        .content_title
          margin-bottom: 14PX
          font-size: 25PX
          font-family: Raleway
          font-weight: bold
          line-height: 25PX
          color: #10CFC9

  .aov_public_why
    padding-bottom: 50PX
    background: #F8F9FA

    .aov_public_content
      display: flex
      flex-direction: column
      align-items: center
      margin-top: 18PX

      .tip
        display: flex
        justify-content: flex-start
        margin-bottom: 10PX

        &:last-child
          margin-bottom: 0

        .why_icon
          margin-right: 15PX
          font-size: 24PX
          color: #22CFC9

        .text_con
          width: 439PX
          font-size: 16PX
          font-family: Roboto
          font-weight: 400
          line-height: 16PX
          color: #364550
          opacity: 0.75

  .aov_public_videoBox
    padding-bottom: 50PX

    .aov_public_video
      margin-top: 50PX

  .aov_public_simple
    background: #F8F9FA
    padding-bottom: 5PX

    .aov_public_label
      margin-bottom: 25PX

    .aov_public_introduce
      font-size: 14PX
      font-weight: 400
      line-height: 26PX
      color: #334455
      opacity: .75
      margin-bottom: 50PX

    .aov_public_video
      margin-top: 52PX
      margin-bottom: 45PX

    .aov_public_content
      width: 1280PX

      @media screen and (max-width: 1280PX)
        width: 100%

      &.delivery_con
        .content_box
          margin-bottom: 25PX

      .content_title
        margin-bottom: 10PX
        text-align: center
        font-size: 26PX
        font-weight: bold
        line-height: 26PX
        color: #10CFC9

        &.font_22
          font-size: 22PX

      .content_label
        max-width: 341PX

      .content_box
        .content_img
          width: 270PX
          height: 250PX
          margin-bottom: 30PX

  .aov_public_brands
    background: #ffffff
    padding-bottom: 50PX

    .swiper
      width: calc(100vw - 20PX)

      .items
        display: flex

        .content_img
          width: 176PX
          margin-right: 18PX
          vertical-align: middle

    .app_public_describe
      margin-bottom: 18PX

  .aov_bottom_box
    width: 100%
    display: flex
    align-items: center
    justify-content: flex-end
    height: 70PX
    padding-right: 7%
    background: #FFFFFF

    .bottom_label
      margin-right: 22PX
      font-size: 16PX
      font-weight: bold
      line-height: 40PX
      color: #334455
      opacity: .35
      text-transform: uppercase

    .child_icon
      margin-left: 22PX
      cursor: pointer

    .icon_sty
      width: 32PX
      height: 44PX
      color: #10CFC9
      cursor: pointer

  .aov_checkbox
    align-self: center
    margin-bottom: 13PX

    .checkbox_label
      margin-bottom: 13PX
      font-size: 14PX
      font-weight: bold
      line-height: 14PX
      color: #334455

    @media screen and (max-height: 720PX)
      margin-bottom: 17PX

  .aov_radio_box
    margin-bottom: 20PX
    width: 100%

    .checkbox_label
      margin-bottom: 13PX
      font-size: 14PX
      font-weight: bold
      line-height: 14PX
      color: #334455

    @media screen and (max-height: 720PX)
      margin-bottom: 17PX

.dialog
  height: 100%
  display: flex
  flex-direction: column
  align-items: center
  padding: 25PX

  .dialog_img
    margin-bottom: 20PX
    width: 67PX

  .title
    margin-bottom: 8PX
    font-size: 18PX
    color: #334455
    font-weight: bold
    line-height: 22PX

  .test
    margin-bottom: 18PX
    font-size: 14PX
    line-height: 18PX
    font-weight: 400

  .dialog_button
    width: 100%
    height: 54PX
    background: #1FC4BC
    color: #fff
    font-size: 18PX
    border-radius: 4PX
    border: 1PX solid #1FC4BC

.arrow
  position: absolute
  left: 50%
  bottom: 1%
  display: flex
  justify-content: center
  align-items: center
  margin-left: -35PX
  width: 70PX
  height: 70PX
  border-radius: 50%
  margin-top: -100PX
  text-decoration: none
  background: #1FC4BC
  text-align: center
  line-height: 70PX
  cursor: pointer

.fa-2x
  color: #F8F9FA
  font-size: 34PX

.bounce
  -moz-animation: bounce 2.8s infinite
  -webkit-animation: bounce 2.8s infinite
  animation: bounce 2.8s infinite

@keyframes bounce
  0%, 20%, 50%, 80%, 100%
    transform: translateY(0)

  40%
    transform: translateY(-15PX)

  60%
    transform: translateY(-10PX)

// 表单验证，不通过的样式
::v-deep
  .error_form
    .mu-input-label
      color: #B00020 !important

    .float
      color: rgba(51, 68, 85, 0.5) !important

    .i-form-item-message
      font-size: 12PX !important
      color: #B00020
      margin-bottom: 6PX
    .mu-text-field
      border: 2PX solid #B00020
::v-deep
  .mu-input
    @media screen and (max-height: 800PX)
      height: 45PX !important

    @media screen and (max-height: 720PX)
      height: 38PX !important

  .mu-input-label
    @media screen and (max-height: 800PX)
      font-size: 14PX

  .float
    transform: translate3d(0, 22PX, 0) scale(1) !important

    @media screen and (max-height: 720PX)
      transform: translate3d(0, 20PX, 0) scale(1) !important

::v-deep
  .is-checked
    .el-radio__inner
      border: 1PX solid #10CFC9 !important
      background: #fff

  .el-radio__inner
    width: 24PX
    height: 24PX
    border: 1PX solid rgba(54,69, 80,0.3)

    &::after
      width: 12PX
      height: 12PX
      background: #10CFC9

  .el-radio__label
    font-size: 16PX
    line-height: 16PX
    font-weight: 400
    padding-left: 6PX
    color: black !important

  .el-radio
    display: flex
    flex-direction: row
    align-items: center
    margin-right: 20PX
    font-size: 0

  .el-radio-group
    display: flex
</style>

<style lang="sass" scoped>
// 处理 element-ui 中 from 样式
::v-deep
  .el-dialog
    height: 256PX
    border-radius: 8PX
    display: flex
    flex-direction: column
    margin: 0 !important
    position: absolute
    top: 45%
    left: 50%
    transform: translate(-50%, -50%)
    max-height: calc(100% - 30PX)
    max-width: calc(100% - 30PX)

    .el-dialog__header
      padding: 0

    .el-dialog__body
      padding: 0
      flex: 1
      overflow: auto

  .el-checkbox__input.is-checked+.el-checkbox__label
    color: #10CFC9 !important

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner
    background-color: #10CFC9 !important
    border-color: #10CFC9 !important

  .el-checkbox__label
    font-size: 16PX
    padding-left: 6PX
    line-height: 16PX
    color: #334455
    font-weight: 400

  .el-checkbox__inner
    height: 24PX !important
    width: 24PX !important
    border-radius: 3PX
    border: 1PX solid #DCDFE6

    &::after
      height: 10PX
      left: 8PX
      top: 3PX
      width: 5PX
      border: 2PX solid #FFF
      border-left: 0
      border-top: 0

  .el-checkbox
    margin-right: 20PX
    font-size: 16PX
    line-height: 16PX

  .el-button
    padding: 15PX
    border: 1PX solid #10CFC9
    text-transform: uppercase

  .mu-input
    width: 475PX
    margin-bottom: 22PX

    @media screen and (max-height: 860PX)
      margin-bottom: 23PX
</style>
